<div dir="ltr">

  <div class="row mb-4">
    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.Name' | translate | safe:'html'" class="text"></span>
      <input [value]="personalInfo.firstName + ' ' + personalInfo.lastName" class="field" readonly type="text">
    </div>
    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.Citizenship' | translate | safe:'html'" class="text"></span>
      <input [value]="citizenshipInfo.citizenship" class="field" readonly type="text">
    </div>
    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.Address' | translate | safe:'html'" class="text"></span>
      <input [value]="addressInfo.address1 + ', ' + addressInfo.address2" class="field" readonly type="text">
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.City' | translate | safe:'html'" class="text"></span>
      <input [value]="addressInfo.city" class="field" readonly type="text">
    </div>

    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.Country' | translate | safe:'html'" class="text"></span>
      <input [value]="addressInfo.countryName" class="field" readonly type="text">
    </div>

    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.DateOfBirth' | translate | safe:'html'" class="text"></span>

      <div class="field-group">
        <input [value]="day" class="field" readonly type="text">
        <input [value]="month" class="field" readonly type="text">
        <input [value]="year" class="field" readonly type="text">
      </div>
    </div>
  </div>

  <div class="row mb-4">

    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.USTaxId' | translate | safe:'html'" class="text"></span>
      <input class="field" readonly type="text">
    </div>

    <div class="col-xl-5 col-12 place-self-end">
      <div [innerHTML]="'Substitute.Resident' | translate | safe:'html'" class="text"></div>
    </div>

    <div class="col-xl-3 col-12 place-self-end">
      <input [value]="addressInfo.countryName" class="field" readonly type="text">
    </div>
  </div>

  <div class="row mb-4">

    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.ResidentCountry' | translate | safe:'html'" class="text"></span>
      <input [value]="addressInfo.countryName" class="field" readonly type="text">
    </div>

    <div class="col-xl-4 col-12 place-self-end">
      <span [innerHTML]="'Substitute.ResidentTaxId' | translate | safe:'html'" class="text"></span>
      <input [value]="citizenshipInfo.idNumber" class="field" readonly type="text">
    </div>
  </div>

  <div class="row mb-4 certification">

    <h1 [innerHTML]="'Substitute.CertificationTitle' | translate | safe:'html'" class="header">
    </h1>
    <p [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:0 | safe:'html'" class="additional-info">
    </p>
    <ul class="additional-info">
      <li [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:1 | safe:'html'">
      </li>
      <li [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:2 | safe:'html'">
      </li>
      <li [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:3 | safe:'html'">
      </li>
    </ul>

    <p class="additional-info">
      <span [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:4 | safe:'html'"></span>
      <span [innerHTML]="'Substitute.CertificationInfo' | translate | translateCut:5 | safe:'html'"></span>
    </p>

    <h1 [innerHTML]="'Substitute.SignatureTitle' | translate | safe:'html'" class="header sub-header">
    </h1>
    <p [innerHTML]="'Substitute.SignatureInfo' | translate | safe:'html'" class="additional-info">
    </p>
  </div>

  <div *ngIf="signatureModel" class="row">
    <form [formGroup]="substituteForm" id="substituteStage">
      <h1 [innerHTML]="'Substitute.SignatureTitle' | translate | safe:'html'" class="header best-header-in-the-world">
      </h1>

      <input [value]="signatureModel.signatureName" class="field mb-3" readonly type="text">

      <div *ngIf="!getIsSignatureAccepted() && navigationService.isMobile" class="error-text">
        <span [innerHTML]="'Substitute.SignatureNotAccepted' | translate | safe:'html'"></span>
      </div>

      <mat-checkbox (change)="updateUser()"
                    class="switch" formControlName="signatureAccept"
                    name="signatureAccept">
        <span [innerHTML]="'Substitute.SignatureAccept' | translate | safe:'html'"></span>
      </mat-checkbox>

      <div *ngIf="!getIsSignatureAccepted() && !navigationService.isMobile" class="error-text">
        <span [innerHTML]="'Substitute.SignatureNotAccepted' | translate | safe:'html'"></span>
      </div>
    </form>
  </div>
</div>
